import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function SuccessCard() {
  const themeColor = 'rgba(244, 147, 0, 1)'; // currentnav

  return (
    <div className="min-h-screen bg-[#EBF0F5] flex items-center justify-center p-4">
      <motion.div
        className="bg-white p-10 rounded-lg shadow-lg text-center"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        <motion.div
          className="rounded-full w-48 h-48 mx-auto flex items-center justify-center"
          style={{ backgroundColor: 'rgba(244, 147, 0, 0.1)' }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 120 }}
        >
          <motion.i
            className="text-[100px] font-bold"
            style={{ color: themeColor }}
            initial={{ rotate: -180, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            ✓
          </motion.i>
        </motion.div>

        <motion.h1
          className="text-4xl font-extrabold font-[Nunito] mt-6"
          style={{ color: themeColor }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
        >
          Success
        </motion.h1>

        <motion.p
          className="text-[#404F5E] text-lg font-[Nunito] mt-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          We received your purchase request;
          <br /> we'll be in touch shortly!
          <Link
            to="/"
            className="mt-4 block hover:underline font-semibold"
            style={{ color: themeColor }}
          >
            <i className="bx bx-arrow-back"></i> Back to Home
          </Link>
        </motion.p>
      </motion.div>
    </div>
  );
}
